import { IconProps } from '@phosphor-icons/react';

export const GoalIcon = ({ size = 24, height, width, color = '#3B82F6', ...rest }: IconProps) => (
    <svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            d="M8.16634 10.8333H13.833M8.16634 5.16667H13.833M2.83301 5.75L3.94412 6.5L6.16634 3.5M2.83301 11.75L3.94412 12.5L6.16634 9.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
